import { render, staticRenderFns } from "./Shangtu.vue?vue&type=template&id=3b2563a4&"
import script from "./Shangtu.vue?vue&type=script&lang=js&"
export * from "./Shangtu.vue?vue&type=script&lang=js&"
import style0 from "./Shangtu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports